import { StyledBankIdButton, StyledButton } from "./styled";

import { useTexts } from "Components/TextContext";
import { Button } from "Components/TextContext/commonComponentEnums";
import { Variants } from "Components/TextContext/textConstants";
import { buttonTrackId } from "Utils/analytics";
import React from "react";

interface Props {
  readonly handleLogin: () => void;
  readonly setLoginMode?: (mode: boolean) => void;
}
export const BankIdLogin = ({
  handleLogin,
  setLoginMode,
}: Props): React.ReactElement => {
  const { getText } = useTexts();

  return (
    <>
      <StyledBankIdButton
        trackId={buttonTrackId(
          getText(Button.LOGIN_BANKID, { variant: Variants.ENGLISH }),
        )}
        onClick={handleLogin}
      >
        {getText(Button.LOGIN_BANKID)}
      </StyledBankIdButton>
      {setLoginMode && (
        <StyledButton
          data-trackid={buttonTrackId(
            getText(Button.NO_LOGIN, { variant: Variants.ENGLISH }),
          )}
          onClick={() => setLoginMode(false)}
        >
          {getText(Button.NO_LOGIN)}
        </StyledButton>
      )}
    </>
  );
};
